export enum LibraryType {
    Private = 100,
    Public = 200,
    Purchased = 300
}